var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationRedFilledMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#BC0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41744 9.05329C7.42573 9.34478 7.66442 9.57679 7.95603 9.57679C8.24765 9.57679 8.48634 9.34478 8.49462 9.05329L8.61888 4.68196C8.6295 4.3085 8.32965 4 7.95603 4C7.58242 4 7.28257 4.3085 7.29318 4.68196L7.41744 9.05329ZM7.2002 11.2527C7.2002 11.6654 7.53479 12 7.94754 12H7.96453C8.37727 12 8.71187 11.6654 8.71187 11.2527C8.71187 10.8399 8.37727 10.5053 7.96453 10.5053H7.94754C7.53479 10.5053 7.2002 10.8399 7.2002 11.2527Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#BC0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationRedFilledMarker);
export default __webpack_public_path__ + "static/media/exclamation_red_filled_marker.790080e61e7337db38fb7cf89d758e2b.svg";
export { ForwardRef as ReactComponent };